import { Icon } from 'src/components/icon/Icon';
import { Box, IconButton } from 'src/components/mui';
import { useMenuContext } from '../../context';
import { isMobileOnly } from 'react-device-detect';

type Props = {
  onOpen: () => void;
  onClose?: () => void;
  setMenuIsOpen: (menuIsOpen: boolean) => void;
  menuIsOpen: boolean;
  icon: string | React.ReactNode;
  hasBeenOpened: boolean;
  openOnHover?: boolean;
  active?: boolean;
  bgColor?: string;
  textColor?: string;
  isBM?: boolean;
  isFirst?: boolean;
  isLast?: boolean;
  customIcon?: string;
};

export default function Button({
  onOpen,
  onClose,
  setMenuIsOpen,
  menuIsOpen,
  icon,
  hasBeenOpened,
  openOnHover,
  active,
  bgColor,
  textColor,
  isBM,
  isFirst,
  isLast,
  customIcon,
}: Props) {
  const { rtl } = useMenuContext();

  return (
    <Box
      onMouseEnter={
        openOnHover && !menuIsOpen
          ? () => {
              onOpen();
              setTimeout(() => {
                setMenuIsOpen(true);
              }, 300);
            }
          : undefined
      }
      sx={{
        ...(rtl && !hasBeenOpened
          ? {
              marginLeft: '16px !important',
            }
          : {}),
      }}
    >
      <IconButton
        sx={{
          background: bgColor,
          color: textColor || 'white',
          backdropFilter: 'blur(10.5px)',
          ...(!hasBeenOpened ? { width: '50px' } : {}),
          '&:hover': {
            background: bgColor,
            opacity: 0.8,
          },

          borderTopLeftRadius: isFirst ? '8px' : '0px',
          borderBottomLeftRadius: isLast ? '8px' : '0px',
          borderTopRightRadius: '0px',
          borderBottomRightRadius: '0px',
          width: '40px',
        }}
        onClick={active && (!isBM || isMobileOnly) ? onClose : onOpen}
      >
        {customIcon ? (
          <img src={customIcon} alt="custom-icon" width={24} height={24} />
        ) : active && !isBM ? (
          icon
        ) : typeof icon === 'string' ? (
          <Icon type="fas" icon={icon} color={textColor} />
        ) : (
          icon
        )}
      </IconButton>
    </Box>
  );
}
